import { useEffect, useState } from "react";
import {
  Box,
  Typography,
  CircularProgress,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Chip,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import CircleIcon from "@mui/icons-material/Circle";
import FilterListIcon from "@mui/icons-material/FilterList";
import CloseIcon from "@mui/icons-material/Close";
import { useTranslation } from "react-i18next";
import { decryptToken } from "../../../Utlis/Encryption";
import { BASE_URL } from "../../../components/BaseUrl";
import { toast, Toaster } from "react-hot-toast";
import CustomText, { textStyles } from "../../../components/CustomText";
import CustomButton from "../../../components/CustomButton";
import emptyscreen from "../../../assets/Dashboard/emptyscreen.svg"

import {
  MapContainer,
  TileLayer,
  Marker,
  Tooltip,
  useMap,
} from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import MultiSelectDropdown from "../../../components/MultiSelectionDropdown"; // ✅ your custom dropdown

const defaultCenter = [33.6844, 73.0479];

const pinIcon = new L.Icon({
  iconUrl: "https://unpkg.com/leaflet@1.7/dist/images/marker-icon.png",
  iconSize: [25, 41],
  iconAnchor: [12, 41],
});

const FitBounds = ({ locations }) => {
  const map = useMap();
  useEffect(() => {
    if (locations.length > 0) {
      const bounds = L.latLngBounds(
        locations.map((m) => [m.position.lat, m.position.lng])
      );
      map.fitBounds(bounds, { padding: [50, 50] });
    }
  }, [locations, map]);
  return null;
};

function InfoPreviewCard({ m }) {
  const p = m?.infoPreview || {};
  return (

    <Box
      sx={{
        p: 1,
        minWidth: 220,
        maxWidth: 280,
        bgcolor: "#fff",
        border: "1px solid #E6E9EF",
        borderRadius: 1.5,
        // boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
        fontFamily: "Poppins, sans-serif",
        pointerEvents: "auto",          // allow interaction if needed
        zIndex: 9999,                   // always on top
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 0.5 }}>
        <Typography sx={{ fontSize: 12, fontWeight: 600, color: "#2C384C", mr: 1 ,
                fontFamily: 'Poppins, sans-serif',
        }} noWrap>
          {m.title || p.tradeName || p.legalName}
        </Typography>
        {!!m.status && (
          <Chip
            size="small"
            label={m.status}
            sx={{
              height: 20,
              fontSize: 10,
              textTransform: "capitalize",
              // bgcolor: "#fff8e1",

            }}
          />
        )}
      </Box>

      {p.tradeName && (
        <Typography sx={{ fontSize: 12, color: "#6B778C",
                fontFamily: 'Poppins, sans-serif',
         }} noWrap>
          {p.tradeName}
        </Typography>
      )}

      <Box sx={{ mt: 0 }}>
        {p.adminName && (
          <Typography sx={{ fontSize: 11, color: "#44546F",      fontFamily: 'Poppins, sans-serif', }}>
            Admin: <b>{p.adminName}</b>
          </Typography>
        )}
        {p.adminEmail && (
          <Typography sx={{ fontSize: 11, color: "#6B778C",      fontFamily: 'Poppins, sans-serif', }} noWrap>
            {p.adminEmail}
          </Typography>
        )}
        {p.adminPhone && (
          <Typography sx={{ fontSize: 11, color: "#6B778C" ,      fontFamily: 'Poppins, sans-serif',}}>
            {p.adminPhone}
          </Typography>
        )}
      </Box>

      {(p.address || m?.region) && (
        <Typography sx={{ mt: 0, fontSize: 11,      fontFamily: 'Poppins, sans-serif', color: "#6B778C" }}>
          {p.address || `${m.region?.city || ""}${m.region?.city ? ", " : ""}${m.region?.state || ""}${m.region?.state ? ", " : ""}${m.region?.country || ""}`}
        </Typography>
      )}

      {(p.businessSector || p.businessType) && (
        <Typography sx={{ mt: 0, fontSize: 11, color: "#6B778C",      fontFamily: 'Poppins, sans-serif', }}>
          {p.businessSector ? `${p.businessSector}` : ""}{p.businessSector && p.businessType ? " · " : ""}{p.businessType || ""}
        </Typography>
      )}

      {p.assignmentType && (
        <Typography sx={{ mt: 0, fontSize: 11, color: "#6B778C" ,      fontFamily: 'Poppins, sans-serif',}}>
          Assignment: {p.assignmentType}
        </Typography>
      )}
    </Box>
  );
}

const MapCities = () => {

  const rawEncryptedToken = localStorage.getItem("token");
  const token = rawEncryptedToken ? decryptToken(rawEncryptedToken) : null;
  const { t } = useTranslation();
  const [markers, setMarkers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState(null);

  const [filterApplied, setFilterApplied] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);

  const [locations, setLocations] = useState({
    countries: [],
    states: [],
    cities: [],
  });

  const [selectedCountries, setSelectedCountries] = useState([]);
  const [selectedStates, setSelectedStates] = useState([]);
  const [selectedCities, setSelectedCities] = useState([]);

  useEffect(() => {
    if (!token) return;
    fetchCompanies();
  }, [token]);

  const fetchCompanies = async () => {
    setLoading(true);
    setErr(null);
    try {
      const res = await fetch(`${BASE_URL}/maps/my-companies`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const json = await res.json();
      if (!res.ok || json.error)
        throw new Error(json.message || "Failed to fetch");
      setMarkers(json.data?.markers || []);
    } catch (e) {
      setErr(e.message || "Failed to load");
    } finally {
      setLoading(false);
    }
  };

  const fetchLocationLists = async () => {
    try {
      const res = await fetch(
        `${BASE_URL}/account-executive/statistics/location-lists?type=all&limit=100&user_type=all`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      const json = await res.json();
          const data = json.data?.data || { countries: [], states: [], cities: [] };

       // 🔥 Console logs for debugging
    console.log("📌 Countries:", data.countries);
    console.log("📌 States:", data.states);
    console.log("📌 Cities:", data.cities);
      if (!res.ok || json.error) throw new Error(json.message);
      setLocations(json.data?.data || { countries: [], states: [], cities: [] });
    } catch (e) {
      console.error(e);
    }
  };

  const handleFilterClick = () => {
    setModalOpen(true);
    fetchLocationLists();
  };

  const handleApplyFilter = async () => {
    setModalOpen(false);
    setLoading(true);
    try {
      let url = `${BASE_URL}/account-executive/statistics/location-based?type=pins&user_type=company_admin`;

      if (selectedCountries.length > 0)
        url += `&country=${encodeURIComponent(selectedCountries.join(","))}`;
      if (selectedStates.length > 0)
        url += `&state=${encodeURIComponent(selectedStates.join(","))}`;
      if (selectedCities.length > 0)
        url += `&city=${encodeURIComponent(selectedCities.join(","))}`;

      const res = await fetch(url, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const json = await res.json();
      const pins = json.data?.pins || [];
      if (pins.length === 0) {
        toast.error("No data found");
        return;
      }
      setMarkers(pins);
      setFilterApplied(true);
    } catch (e) {
      toast.error("Error loading pins");
    } finally {
      setLoading(false);
    }
  };

  const handleClearFilter = () => {
    setFilterApplied(false);
    fetchCompanies();
    setSelectedCountries([]);
    setSelectedStates([]);
    setSelectedCities([]);
  };

  return (
    <Box sx={{ mt: 2 }}>

      {/* Map */}
      <Box
        sx={{
          width: "100%",
          height: 250,
          borderRadius: 2,
          mb: 2,
          overflow: "hidden",
          position: "relative",
          // ✅ allow tooltip cards to overflow
          "& .leaflet-tooltip-pane, & .leaflet-popup-pane": {
            overflow: "visible",
            zIndex: 9999,
          },
        }}
      >
        {loading ? (
          <CircularProgress />
        ) : (
          <MapContainer
            center={defaultCenter}
            zoom={3}
                style={{ height: "100%", width: "100%" }}
          >
            <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
            {markers.map((m) => (
              <Marker
                key={m.id}
                position={[m.position.lat, m.position.lng]}
                icon={pinIcon}
              >
                <Tooltip>
                  <InfoPreviewCard m={m} />
                </Tooltip>
              </Marker>
            ))}
            <FitBounds locations={markers} />
          </MapContainer>
        )}
      </Box>

<Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
  <Typography variant="h6">{t("companies")}</Typography>


  {markers.length > 0 && (
  <Box sx={{ position: "relative", display: "inline-flex" }}>
    {/* Filter Button (opens modal) */}
    <IconButton
      onClick={handleFilterClick}
      sx={{
        border: "1px solid #E0E0E0",
        borderRadius: "8px",
        bgcolor: filterApplied ? "#1976d2" : "#fff",
        color: filterApplied ? "#fff" : "#44546F",
          "&:hover": {
            bgcolor:filterApplied ? "#1976d2": "#fff",
          },
      }}
    >
      <FilterListIcon />
    </IconButton>

    {/* Cross shown only when filter is applied */}
    {filterApplied && (
      <IconButton
        size="small"
        onClick={(e) => {
          e.stopPropagation();   // ⛔ prevent opening modal
          handleClearFilter();   // ✅ clear filters
        }}
        sx={{
          position: "absolute",
          top: -6,
          right: -6,
          bgcolor: "#fff",
          border: "1px solid #ccc",
          p: 0.3,
          "&:hover": {
            bgcolor: "#f5f5f5",
          },
        }}
      >
        <CloseIcon sx={{ fontSize: 14, color: "#444" }} />
      </IconButton>
    )}
  </Box>
   )}
</Box>


      {/* Filter Modal */}
      <Dialog open={modalOpen} onClose={() => setModalOpen(false)} fullWidth >
        {/* <DialogTitle></DialogTitle> */}
                 <CustomText sx={{ ...textStyles.h1, fontSize: 22,textAlign:"left", pl:3, pt:2, pb:2, fontWeight: 600, color: '#2C384C' }}>
{t("filterByLocation")}                 </CustomText>
        <DialogContent dividers>

                <MultiSelectDropdown
              label={t("states")}
            name="states"
            values={selectedStates}
            onChange={(e) => setSelectedStates(e.target.value)}
            options={locations.states.map((s) => ({
              label: `${s.name} - ${s.country} `,
              value: s.name,
            }))}
          />

          <MultiSelectDropdown
             label={t("countries")}
            name="countries"
            values={selectedCountries}
            onChange={(e) => setSelectedCountries(e.target.value)}
            options={locations.countries.map((c) => ({
              label: `${c.name}`,
              value: c.name,
            }))}
          />
    
          <MultiSelectDropdown
             label={t("cities")}
            name="cities"
            values={selectedCities}
            onChange={(e) => setSelectedCities(e.target.value)}
            options={locations.cities.map((c) => ({
              label: `${c.name} - ${c.country}`,
              value: c.name,
            }))}
          />
        </DialogContent>
        <DialogActions>
 <Box sx={{ mt: 2, mb:2 ,display: 'flex',flexWrap:"wrap",gap: 2 }}>
        <CustomButton size='small'  label={t("cancel")}  onClick={() => setModalOpen(false)}  sx={{
      fontSize: 15,
      textTransform: 'none',
      borderRadius: '5px',
      fontFamily: 'Poppins, sans-serif',
      color: '#006EC2',
      backgroundColor:"white",
      border: "2px solid #006EC2",
      px: 3,
      py: 1,
      height: 'fit-content',
       "&:hover": {
    backgroundColor: "white",   // ✅ stays white
    border: "2px solid #006EC2", // ✅ keeps border
    color: "#006EC2",            // ✅ keeps text color
  },
    }} />
          <CustomButton size='medium'  label={t("apply")}  onClick={handleApplyFilter}/>
          </Box>
        </DialogActions>
      </Dialog>

  

      {markers.length === 0 ? (
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      py: 4,
      border: "1px solid #E0E0E0",
      borderRadius: "8px",
      backgroundColor: "#fff",
    }}
  >
    <img
      src={emptyscreen} // ✅ put your empty illustration here
      alt="No companies"
      style={{ width: 120, height: "auto", marginBottom: 12 }}
    />
    <Typography
      sx={{
        fontFamily: "Poppins, sans-serif",
        fontSize: 16,
        fontWeight: 500,
        color: "#6B778C",
      }}
    >
      No companies found yet
    </Typography>
  </Box>
) : (
  <List
    dense
    sx={{
      backgroundColor: "#fff",
      border: "1px solid #E0E0E0",
      borderRadius: "8px",
      p: 1,
      height:"300px",
      overflowY:"auto"
    }}
  >
    {markers.map((m) => (
      <ListItem key={m.id} sx={{ gap: 1, py: 0.5 }}>
        <ListItemIcon sx={{ minWidth: 20 }}>
          <CircleIcon sx={{ fontSize: 8, color: "#44546F" }} />
        </ListItemIcon>
        <ListItemText
          primary={m.title}
          primaryTypographyProps={{
            sx: {
              fontFamily: "Poppins, sans-serif",
              fontSize: "16px",
              fontWeight: 500,
              color: "#44546F",
            },
          }}
        />
      </ListItem>
    ))}
  </List>
)}

    </Box>
  );
};

export default MapCities;







































